import { useReducedMotion } from "../../lib/motion/index.js";
import { useSidebarAnimStore } from "../../stores/index.js";

/**
 * Spread-props for every `Reorder.Item` living inside the sidebar (filter
 * sections + the topic/label/calendar entry rows). While the sidebar itself is
 * being resized or collapse/expand-animated, their layout (FLIP) animations
 * would chase each width tick — visibly compressing opposite to the drag and
 * snapping back on release — so the layout transition goes instant for the
 * gesture's duration (and always under reduced motion).
 */
export function useSidebarReorderProps(): { transition?: { duration: number } } {
  const reduce = useReducedMotion();
  const gesture = useSidebarAnimStore((s) => s.active);
  return reduce || gesture ? { transition: { duration: 0 } } : {};
}
